import { getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';
import { Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import { payment, whitelabel } from '../../../core/state';
import { EnqueueSnackbar } from '../../../core/state/general/general.types';
import { generalActions } from '../../../core/state/general/generalActions';
import { utils } from '../../../utils';
import * as Actions from '../../../weborder/actions/Actions';
import { ContactFormType } from '../../../weborder/Api';
import * as Api from '../../../weborder/Api';
import * as Data from '../../../weborder/Data';
import {
  basketActions,
  paymentActions,
  userActions,
} from '../../../weborder/redux';
import { cookieSelectors } from '../../../weborder/selectors';
import { storage } from '../../../weborder/services/storageServices';
import * as Store from '../../../weborder/Store';
import { ProfileMenu } from './ProfileMenu';

export type StateProps = ReturnType<typeof mapStateToProps>;
export type DispatchProps = ReturnType<typeof mapDispatchToProps>;

const mapStateToProps = (state: Store.State) => {
  let contactFormType = ContactFormType.None;
  const configData = whitelabel.selectors.getAppConfig(state);
  if (configData) {
    contactFormType = configData.ContactFormType;
  }

  const languageCode = utils.get.activeLanguageCode(state.locale.languages);

  return {
    configData,
    collectionSummaries: state.flipdish.CollectionSummaries,
    contactFormType,
    customer: state.flipdish.Customer,
    hasDisableNonEssentialCookies: cookieSelectors.hasDisableNonEssentialCookies(
      state,
    ),
    hasGdprCookieFeatureFlag: cookieSelectors.hasGdprCookieFeatureFlag(state),
    intercom: state.intercom,
    languageCode,
    payments: payment.selectors.getRemovablePayments(state),
    savedCardCount: payment.selectors.getRemovablePayments(state).length,
    showRestaurantList: state.flipdish.Config.showRestaurantList,
    translate: getTranslate(state.locale) as any,
  };
};

const mapDispatchToProps = (
  dispatch: ThunkDispatch<Store.State, {}, Action>,
) => ({
  actions: {
    cancelAddCardBridge: (): void => {
      dispatch(paymentActions.cancelAddBridge());
    },
    clearBasketStatus: (): void => {
      dispatch(
        basketActions.updateBasket({
          error: undefined,
          status: 'loaded',
          validationErrors: [],
        }),
      );
    },
    changeLanguage: (lang: string) => {
      dispatch(Actions.ChangeLanguage(lang));
    },
    clearDeliveryLocations: () => {
      dispatch(Actions.ClearDeliveryLocations());
    },
    creditCardPaymentAdded: (
      props: paymentActions.CreditCardPaymentAddedProps,
    ): void => {
      dispatch(paymentActions.creditCardPaymentAdded(props));
    },
    deletePaymentMethod: (payload: { paymentId: string }) => {
      dispatch(paymentActions.paymentRemoved(payload));
    },
    logoutSuccessBridge: () => {
      dispatch(userActions.logoutSuccessBridge());
    },
    pushLoginUrl: (url: string): void => {
      dispatch(Actions.PushAfterLogin(url));
    },
    setAfterProfilePanelUrl: (url: string): void => {
      dispatch(generalActions.setAfterProfilePanelUrl(url));
    },
    setCustomer: (customer: Data.Async<Api.Customer>) => {
      dispatch({
        type: 'SET_CUSTOMER',
        payload: customer,
      });
      storage.removeItem('flipdish-customer');
    },
    setCustomerEmail: (
      customerEmail: string,
      enqueueSnackbar: EnqueueSnackbar,
    ) => {
      dispatch(Actions.SetCustomerEmail(customerEmail, enqueueSnackbar));
    },
    setSmsEnabled: (state: boolean) => {
      dispatch(Actions.SetSmsEnabled(state));
    },
    setUserName: (name: string, enqueueSnackbar: EnqueueSnackbar) => {
      dispatch(Actions.SetCustomerName(name, enqueueSnackbar));
    },
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ProfileMenu);
